// /* eslint-disable no-param-reassign */
// /// Zappar for ThreeJS Examples
// /// Instant Tracking 3D Model

// // In this example we track a 3D model using instant world tracking
import './index.css';
import Project from "./Experience/Project"
const project = new Project()

